<template>
  <v-card
  flat
  class="pa-0 ga-0 d-flex justify-center align-center flex-column flex-sm-row"
  color=""
  rounded="lg"
  >
    <div class=" d-flex">
      <Button
      class="ma-2"
      :slim="true"
      version="action"
      :label="btn_1_content"
      @click="applyUpdate(version)"
      />
      <Button
      class="ma-2"
      :slim="true"
      version="secondary"
      :label="'Close'"
      @click="modalStore.closeModal()"
      />
    </div>
  </v-card>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import Button from '@/components/ComponentLibrary/Button.vue';
import { applyUpdate } from '@/services/mobile_app/liveUpdateService';
import { BundleInfo } from '@capgo/capacitor-updater';
import { useModalStore } from '@/store/modalStore';

const modalStore = useModalStore();
const btn_1_content = ref('Apply Update');

const props = defineProps<{
  version: BundleInfo;
}>();



</script>

<style lang="scss">

</style>